module.exports = __webpack_public_path__ + "img/igloo_small.ce3ac3c6.png";